import { ApiPath } from "enums";
import { Get } from "utils";

export const getRFID = async ({ ...query }) => {
  const res = await Get(`${ApiPath.RFIDTopups}`, query);
  return res.data;
};
